import React from "react"
import {Box, capitalize, Typography} from "@mui/material"


export default function statusColumn() {
  return {
    name: "status",
    render: value => <Box sx={{  display: 'flex', justifyContent: 'center'  }}>
      <Typography variant="body1">
        {capitalize(value)}
      </Typography>
    </Box>
  }
}